import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { class: "st_myreg_customize_form" }
const _hoisted_5 = {
  name: "myreg_form",
  ENCTYPE: "multipart/form-data",
  style: {"margin":"0"}
}
const _hoisted_6 = { class: "st_myreg_form" }
const _hoisted_7 = { class: "st_myreg_agree_wrap st_myreg_mgt" }
const _hoisted_8 = { class: "st_myreg_agree" }
const _hoisted_9 = { class: "agree_check_box" }
const _hoisted_10 = { class: "st_myreg_btn_wrap" }
const _hoisted_11 = {
  key: 0,
  class: "success-message",
  style: {"color":"blue","margin-top":"10px","text-align":"center"}
}

import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import { ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/bbs/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { getCallable } from "@/config/env"; // Firebase Callable Function
import { OrgMyreg } from "@/model/myreg"; // Myreg 모델 임포트
import { useNotification, NButton } from "naive-ui"; // NButton 임포트 추가
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'OrgForm',
  setup(__props) {

const useAlert = useAlertDialog();

const router = useRouter();
const route = useRoute();
const notification = useNotification();

const initialFormData: OrgMyreg = {
  orgName: "",
  deptName: "",
  name: "",
  address: {
    postCode: "",
    address: "",
    addressDetail: "",
  },
  examineeCount: 0,
  phoneNumber: "",
  email: "",
  content: "",
  targetProduct: "",
  privacyAgreement: "", // 'agree' 또는 'disagree'
};

const myregFormData = ref<OrgMyreg>({ ...initialFormData });
const isLoading = ref<boolean>(false);
const successMessage = ref<string | null>(null);

const addOrgMyreg = getCallable("addOrgMyreg");

const openPostcodeSearch = async () => {
  if (
    typeof (window as any).daum === "undefined" ||
    typeof (window as any).daum.Postcode === "undefined"
  ) {
    await useAlert(
      "Daum 우편번호 서비스가 로드되지 않았습니다. 페이지를 새로고침하거나 관리자에게 문의하세요."
    );
    return;
  }
  new (window as any).daum.Postcode({
    oncomplete: (data: any) => {
      let addr = ""; // 주소 변수
      let extraAddr = ""; // 참고항목 변수

      //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
      if (data.userSelectedType === "R") {
        // 사용자가 도로명 주소를 선택했을 경우
        addr = data.roadAddress;
      } else {
        // 사용자가 지번 주소를 선택했을 경우(J)
        addr = data.jibunAddress;
      }

      // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
      if (data.userSelectedType === "R") {
        // 법정동명이 있을 경우 추가한다. (법정리는 제외)
        // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
        if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
          extraAddr += data.bname;
        }
        // 건물명이 있고, 공동주택일 경우 추가한다.
        if (data.buildingName !== "" && data.apartment === "Y") {
          extraAddr +=
            extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
        }
        // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
        if (extraAddr !== "") {
          extraAddr = " (" + extraAddr + ")";
        }
      }

      myregFormData.value.address.postCode = data.zonecode;
      myregFormData.value.address.address = addr + extraAddr;
      document.getElementById("addressDetail")?.focus(); // 상세주소 필드로 포커스 이동
    },
  }).open();
};

const submitInquiry = async () => {
  successMessage.value = null;

  if (
    !myregFormData.value.orgName ||
    !myregFormData.value.deptName ||
    !myregFormData.value.examineeCount ||
    !myregFormData.value.name ||
    !myregFormData.value.phoneNumber ||
    !myregFormData.value.email
  ) {
    await useAlert("필수 입력 항목을 모두 채워주세요.");
    return;
  }
  if (myregFormData.value.privacyAgreement !== "agree") {
    await useAlert("개인정보 수집·이용에 동의해주세요.");

    return;
  }

  isLoading.value = true;

  try {
    const result: any = await addOrgMyreg(myregFormData.value);
    if (result.data && result.data.error) {
      throw new Error(result.data.message || "문의 등록에 실패했습니다.");
    }
    notification.success({
      title: "성공",
      description: "문의가 성공적으로 등록되었습니다.",
      duration: 2000,
      onAfterLeave: () => {
        router.push(`${USER_ROUTES.Home.Path}`);
      },
    });
  } catch (error: any) {
    console.error("Error submitting inquiry:", error);

    notification.error({
      title: "실패",
      description:
        error.message ||
        "문의 등록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
      duration: 2000,
    });
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  const productId = route.params.pid as string;
  if (productId == "P_PUTT") {
    myregFormData.value.targetProduct =
      "PUTT2.0 다중재능검사_초등학생용(고)\r\nPUTT2.0 다중재능검사_중학생용\r\nPUTT2.0 다중재능검사_고등학생용\r\nPUTT2.0 다중재능검사_대학생용";
  } else if (productId == "P_TOCC") {
    myregFormData.value.targetProduct =
      "TOCC 창의역량검사_초등학생용(고)\r\nTOCC 창의역량검사_청소년용\r\nTEC 창의역량검사_(예비)전문가용";
  } else if (productId == "P_PUTT_TOCC") {
    myregFormData.value.targetProduct =
      "PUTT2.0_초등학생용(고) + TOCC아동용(고)\r\nPUTT2.0_중학생용 + TOCC_청소년용\r\nPUTT2.0_고등학생용 + TOCC_청소년용\r\nPUTT2.0_대학생용 + TEC_(예비)전문가용";
  } else if (productId == "C_PUTT") {
    myregFormData.value.targetProduct =
      "PUTT2.0기반 상담코칭_초등학생 (고)\r\nPUTT2.0기반 상담코칭_중학생PUTT2.0기반 상담코칭_고등학생\r\nPUTT2.0기반 상담코칭_대학생";
  } else if (productId == "C_TOCC") {
    myregFormData.value.targetProduct =
      "TOCC기반 상담코칭_초등학생 (고)\r\nTOCC기반 상담코칭_중학생\r\nTOCC기반 상담코칭_고등학생\r\nTOCC기반 상담코칭_대학생";
  } else if (productId == "C_PUTT_TOCC") {
    myregFormData.value.targetProduct =
      "PUTT‧TOCC 상담코칭_초등학생 (고)\r\nPUTT‧TOCC 상담코칭_중학생\r\nPUTT‧TOCC 상담코칭_고등학생\r\nPUTT‧TEC 상담코칭_대학생";
  } else if (productId == "Talent") {
    myregFormData.value.targetProduct =
      "PUTT2.0 기반 재능탐색 프로젝트_초등학생(고)\r\nPUTT2.0 기반 진로탐색 프로젝트_중학생\r\nPUTT2.0 기반 전공탐색 프로젝트_고등학생\r\nPUTT2.0 기반 직업탐색 프로젝트_대학생";
  } else if (productId == "Startup") {
    myregFormData.value.targetProduct =
      "재능 발견으로 꿈을 창업하다!_초등학생(고)\r\n재능 발휘로 꿈을 창업하다!_중학생\r\n재능 디자인으로 꿈을 창업하다!_고등학생용";
  } else if (productId == "Career") {
    myregFormData.value.targetProduct =
      "진로코칭지도사 체험 활동_초등학생(고)\r\n진로코칭지도사 체험 활동_중학생\r\n진로코칭지도사 체험 활동_고등학생\r\n진로코칭지도사 체험 활동_대학생용";
  } else if (productId == "Growth") {
    myregFormData.value.targetProduct =
      "성장-폴리오 중학생 과정\r\n성장-폴리오 고등학생 과정\r\n성장-폴리오 대학생 과정";
  } else if (productId == "Expert_e") {
    myregFormData.value.targetProduct = "다중재능코칭 전문가 교육 - 초급과정";
  } else if (productId == "Expert_h") {
    myregFormData.value.targetProduct =
      "다중재능코칭 전문가 교육 - 고급과정\r\n※ 이수자에 다중재능코칭전문가 2급 자격증 부여";
  } else if (productId == "Expert_b") {
    myregFormData.value.targetProduct =
      "다중재능코칭 전문가 교육 - 최고과정\r\n※ 이수자에 다중재능코칭전문가 1급 자격증 부여";
  } else if (productId == "Expert_p") {
    myregFormData.value.targetProduct = "성장 – 폴리오 전문가 과정";
  } else {
    myregFormData.value.targetProduct = "기타";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "etc",
      subtitle: "etc",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[33] || (_cache[33] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("[기관] 신청문의"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _cache[25] || (_cache[25] = _createElementVNode("caption", null, " 기본정보 ", -1)),
              _cache[26] || (_cache[26] = _createElementVNode("colgroup", null, [
                _createElementVNode("col", { style: {"width":"250px"} }),
                _createElementVNode("col")
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("th", null, [
                    _createTextVNode("기관명 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v1",
                      id: "s_v1",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((myregFormData.value.orgName) = $event))
                    }, null, 512), [
                      [_vModelText, myregFormData.value.orgName]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("th", null, "우편번호", -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "postCode",
                      id: "postCode",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((myregFormData.value.address.postCode) = $event)),
                      style: {"width":"120px"}
                    }, null, 512), [
                      [_vModelText, myregFormData.value.address.postCode]
                    ]),
                    _createVNode(_unref(NButton), {
                      type: "primary",
                      ghost: "",
                      onClick: openPostcodeSearch,
                      size: "small",
                      style: {"margin-left":"5px"}
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode(" 주소검색 ")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("th", null, "주소", -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "address",
                      id: "address",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((myregFormData.value.address.address) = $event)),
                      style: {"width":"100%"}
                    }, null, 512), [
                      [_vModelText, myregFormData.value.address.address]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[17] || (_cache[17] = _createElementVNode("th", null, "상세주소", -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "addressDetail",
                      id: "addressDetail",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((myregFormData.value.address.addressDetail) = $event)),
                      style: {"width":"100%"}
                    }, null, 512), [
                      [_vModelText, myregFormData.value.address.addressDetail]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("th", null, [
                    _createTextVNode("대상 인원수 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v1",
                      id: "s_v1",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((myregFormData.value.examineeCount) = $event))
                    }, null, 512), [
                      [_vModelText, myregFormData.value.examineeCount]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("th", null, [
                    _createTextVNode("담당 부서 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v1",
                      id: "s_v1",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((myregFormData.value.deptName) = $event))
                    }, null, 512), [
                      [_vModelText, myregFormData.value.deptName]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("th", null, [
                    _createTextVNode("담당자 이름 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v1",
                      id: "s_v1",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((myregFormData.value.name) = $event))
                    }, null, 512), [
                      [_vModelText, myregFormData.value.name]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("th", null, [
                    _createTextVNode("연락처 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v1",
                      id: "s_v1",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((myregFormData.value.phoneNumber) = $event))
                    }, null, 512), [
                      [_vModelText, myregFormData.value.phoneNumber]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[22] || (_cache[22] = _createElementVNode("th", null, [
                    _createTextVNode("이메일 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v3",
                      id: "s_v3",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((myregFormData.value.email) = $event))
                    }, null, 512), [
                      [_vModelText, myregFormData.value.email]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("th", null, "문의대상", -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("textarea", {
                      readonly: "",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((myregFormData.value.targetProduct) = $event)),
                      style: {"width":"100%","height":"150px"}
                    }, null, 512), [
                      [_vModelText, myregFormData.value.targetProduct]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[24] || (_cache[24] = _createElementVNode("th", null, [
                    _createTextVNode("내 용 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "s_t1",
                      id: "s_t1",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((myregFormData.value.content) = $event)),
                      style: {"width":"100%","height":"150px"}
                    }, null, 512), [
                      [_vModelText, myregFormData.value.content]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[31] || (_cache[31] = _createElementVNode("h4", { class: "st_myreg_title" }, "개인정보 수집·이용 동의", -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"st_myreg_agree_box\" data-v-a98076b0><h5 data-v-a98076b0>수집하는 개인정보의 항목</h5><p data-v-a98076b0> 회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. </p><ul data-v-a98076b0><li data-v-a98076b0>수집항목 : 이 름, 핸드폰, 이메일, 내 용, 파일첨부</li><li data-v-a98076b0>개인정보 수집방법 : <span data-v-a98076b0>홈페이지</span></li></ul><h5 data-v-a98076b0>개인정보의 수집 및 이용목적</h5><p data-v-a98076b0>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p><ul data-v-a98076b0><li data-v-a98076b0>연락 및 상담<br data-v-a98076b0></li></ul><h5 data-v-a98076b0>개인정보의 보유 및 이용기간</h5><p data-v-a98076b0> 회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다. </p></div>", 1)),
                _createElementVNode("div", _hoisted_9, [
                  _cache[29] || (_cache[29] = _createElementVNode("input", {
                    type: "checkbox",
                    name: "myreg_privacy_chk",
                    id: "myreg_privacy_chk",
                    value: "1"
                  }, null, -1)),
                  _createElementVNode("span", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "myreg_privacy_radio",
                      id: "myreg_privacy_radio_agree",
                      value: "agree",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((myregFormData.value.privacyAgreement) = $event))
                    }, null, 512), [
                      [_vModelRadio, myregFormData.value.privacyAgreement]
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("label", { for: "myreg_privacy_radio_agree" }, "개인정보 수집·이용에 동의합니다.", -1))
                  ]),
                  _createElementVNode("span", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "myreg_privacy_radio",
                      id: "myreg_privacy_radio_disagree",
                      value: "disagree",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((myregFormData.value.privacyAgreement) = $event))
                    }, null, 512), [
                      [_vModelRadio, myregFormData.value.privacyAgreement]
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("label", { for: "myreg_privacy_radio1" }, "개인정보 수집·이용에 동의하지 않습니다.", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(NButton), {
                type: "primary",
                onClick: submitInquiry,
                loading: isLoading.value,
                disabled: isLoading.value
              }, {
                default: _withCtx(() => _cache[32] || (_cache[32] = [
                  _createTextVNode(" \"확인\" ")
                ])),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            (successMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(successMessage.value), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})